var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.499,
    height: 86.497,
    viewBox: "0 0 86.499 86.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-04",
    transform: "translate(-79.8 -77.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M130.595,285.274a8.7,8.7,0,0,1,1.93-5.4H81.651a8.929,8.929,0,0,0-1.851,5.4,9.025,9.025,0,0,0,9.011,9.01h50.457A8.75,8.75,0,0,1,130.595,285.274Z",
    transform: "translate(0 -130.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M183.37,77.4H131.112A10.823,10.823,0,0,0,120.3,88.209v57.673h45.725a1.8,1.8,0,1,1,0,3.606,5.73,5.73,0,0,0-5.742,5.4,5.128,5.128,0,0,0,5.066,5.408h9.8a10.748,10.748,0,0,0,2.809-7.216V86.407a5.408,5.408,0,1,1,5.407,5.4,1.8,1.8,0,0,0,0,3.6,9.01,9.01,0,1,0,0-18.019ZM131.112,91.811h14.415a1.8,1.8,0,0,1,0,3.6H131.112a1.8,1.8,0,0,1,0-3.6Zm36.038,46.854H131.112a1.8,1.8,0,0,1,0-3.606H167.15a1.8,1.8,0,0,1,0,3.606Zm0-10.812H131.112a1.8,1.8,0,0,1,0-3.606H167.15a1.8,1.8,0,0,1,0,3.606Zm0-10.812H131.112a1.8,1.8,0,0,1,0-3.606H167.15a1.8,1.8,0,0,1,0,3.606Zm0-10.815H131.112a1.8,1.8,0,0,1,0-3.6H167.15a1.8,1.8,0,0,1,0,3.6Z",
    transform: "translate(-26.082)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.14c6fec5051db5abffed2175998a4ed7.svg";
export { ForwardRef as ReactComponent };